import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { mappedChargebacksInfoData } from "mappers";
import { chargebacksDetailsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useUpdateChargebackInfoMutation = (
	chargebackId: string,
	refetchChargebackInfo: Function,
) => {
	const dispatch = useDispatch();

	return useMutation(
		({
			formValues,
		}: {
			formValues: { [key: string]: any };
			setActionFormState?: Function;
		}) => {
			return chargebacksDetailsService.updateChargebackInfo(
				chargebackId,
				mappedChargebacksInfoData(formValues),
			);
		},

		{
			onSuccess(_result, { setActionFormState }) {
				refetchChargebackInfo?.();
				setActionFormState?.(false);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useUpdateChargebackInfoMutation;
